export const detectLang = (): string => {
  const segs = window.location.pathname.split("/");
  return segs[1] || "ru";
};
